import { render, staticRenderFns } from "./ProductTypeCard.vue?vue&type=template&id=593363e4&scoped=true&"
import script from "./ProductTypeCard.vue?vue&type=script&lang=ts&"
export * from "./ProductTypeCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTypeCard.vue?vue&type=style&index=0&id=593363e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593363e4",
  null
  
)

export default component.exports